export default __webpack_public_path__ + "images/6442523ecd9aea0680c5a187acd4aa9e.svg";